"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormControls = exports.FormControlsDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var icon_button_1 = require("../elements/icon-button");
var sprintf_js_1 = require("sprintf-js");
var use_statuses_1 = require("../../hooks/use-statuses");
var toggle_1 = require("../elements/toggle");
exports.FormControlsDefaultProps = {
  submitting: false,
  paginate: false,
  isCreate: true,
  totalPages: 1,
  page: 0,
  onDelete: function () {},
  previousLabel: function () {
    return 'Previous';
  },
  nextLabel: function () {
    return 'Next';
  },
  onPreviousPage: function () {},
  onNextPage: function () {},
  onChangeStatus: function () {}
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    position: relative;\n    min-height: 22px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding-bottom: ", ";\n    width: 100%;\n    position: relative;\n  "], ["\n    display: flex;\n    position: relative;\n    min-height: 22px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    padding-bottom: ", ";\n    width: 100%;\n    position: relative;\n  "])), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    min-height: 0;\n  "], ["\n    min-height: 0;\n  "])))
});
var ButtonsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-grow: 1;\n    position: absolute;\n    top: 0;\n    align-items: center;\n    left: 50%;\n    height: 24px;\n    z-index: 60;\n    transform: translateX(-50%);\n    justify-content: center;\n    font-size: ", ";\n\n    /* span {\n      font-weight: 500;\n      text-transform: uppercase;\n      position: relative;\n    } */\n\n    b {\n      margin-left: ", ";\n    }\n    padding: 0 ", ";\n  "], ["\n    display: flex;\n    flex-grow: 1;\n    position: absolute;\n    top: 0;\n    align-items: center;\n    left: 50%;\n    height: 24px;\n    z-index: 60;\n    transform: translateX(-50%);\n    justify-content: center;\n    font-size: ", ";\n\n    /* span {\n      font-weight: 500;\n      text-transform: uppercase;\n      position: relative;\n    } */\n\n    b {\n      margin-left: ", ";\n    }\n    padding: 0 ", ";\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.UNIT(1), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 26px;\n    padding: 0 ", ";\n  "], ["\n    height: 26px;\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(5)),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0 ", ";\n  "], ["\n    padding: 0 ", ";\n  "])), theme_1.theme.UNIT(6))
});
var SubmitButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    flex-wrap: nowrap;\n  "], ["\n    flex-wrap: nowrap;\n  "])))
});
var StatusAndDeleteStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var StatusToggleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.showDeleteButton && (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-right: ", ";\n      padding-right: ", ";\n      ", ";\n      background-position: top right;\n    "], ["\n      margin-right: ", ";\n      padding-right: ", ";\n      ", ";\n      background-position: top right;\n    "])), theme_1.theme.UNIT(5.5), theme_1.theme.UNIT(5.5), theme_1.theme.DOT_BG('v', 'line-mid', 2, 4));
  }),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(3))
});
var StartEndStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 32px;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: visible;\n    height: auto;\n    border-top: 1px solid ", ";\n    flex-direction: column;\n    z-index: 80;\n    justify-content: center;\n    align-items: flex-start;\n    background: ", ";\n    padding: ", ";\n    display: none;\n\n    ", "\n  "], ["\n    position: absolute;\n    bottom: 32px;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: visible;\n    height: auto;\n    border-top: 1px solid ", ";\n    flex-direction: column;\n    z-index: 80;\n    justify-content: center;\n    align-items: flex-start;\n    background: ", ";\n    padding: ", ";\n    display: none;\n\n    ", "\n  "])), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(3), function (props) {
    return props.isVisible && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      display: flex;\n    "], ["\n      display: flex;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    height: 60px;\n    bottom: 38px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  "], ["\n    height: 60px;\n    bottom: 38px;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    display: flex !important;\n    height: 26px;\n    z-index: 0;\n    padding: 0 ", ";\n    border-top: none;\n    background: none;\n    bottom: 0;\n    position: static;\n  "], ["\n    display: flex !important;\n    height: 26px;\n    z-index: 0;\n    padding: 0 ", ";\n    border-top: none;\n    background: none;\n    bottom: 0;\n    position: static;\n  "])), theme_1.theme.UNIT(4))
});
var StartStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding-bottom: ", ";\n  "], ["\n    padding-bottom: ", ";\n  "])), theme_1.theme.UNIT(4)),
  tablet: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding-bottom: 0;\n  "], ["\n    padding-bottom: 0;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var DeleteButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var MoreButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    position: absolute;\n    right: ", ";\n    top: 2px;\n    display: flex;\n\n    ", "\n  "], ["\n    position: absolute;\n    right: ", ";\n    top: 2px;\n    display: flex;\n\n    ", "\n  "])), theme_1.theme.UNIT(4), function (props) {
    return props.isActive && (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme_1.theme.COLOR('dark'));
  }),
  desktop: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
// -------- Components --------->
var My = {
  Container: styled_components_1.default.div(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Buttons: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), ButtonsStyles),
  SubmitButton: (0, styled_components_1.default)(icon_button_1.SubmitIconButton)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), SubmitButtonStyles),
  MoreButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), MoreButtonStyles),
  StartEnd: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), StartEndStyles),
  Start: styled_components_1.default.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), StartStyles),
  StatusAndDelete: styled_components_1.default.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), StatusAndDeleteStyles),
  StatusToggle: (0, styled_components_1.default)(toggle_1.Toggle)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), StatusToggleStyles),
  DeleteButton: (0, styled_components_1.default)(icon_button_1.DeleteIconButton)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), DeleteButtonStyles)
};
var FormControls = function (props) {
  var entityTypeName = props.entityTypeName,
    onChangeStatus = props.onChangeStatus,
    className = props.className,
    nextLabel = props.nextLabel,
    previousLabel = props.previousLabel,
    submitting = props.submitting,
    paginate = props.paginate,
    totalPages = props.totalPages,
    page = props.page,
    showDeleteButton = props.showDeleteButton,
    onDelete = props.onDelete,
    onNextPage = props.onNextPage,
    onPreviousPage = props.onPreviousPage,
    isCreate = props.isCreate,
    statusValue = props.statusValue,
    startControls = props.startControls;
  var Icons = (0, use_icons_1.useIcons)();
  var t = (0, use_lang_1.useLang)();
  var _a = (0, use_statuses_1.useStatuses)(),
    PUBLISHED = _a.PUBLISHED,
    DRAFT = _a.DRAFT,
    publishedStatus = _a.publishedStatus,
    draftStatus = _a.draftStatus;
  var onLabel = t((publishedStatus === null || publishedStatus === void 0 ? void 0 : publishedStatus.name) || 'Published');
  var offLabel = t((draftStatus === null || draftStatus === void 0 ? void 0 : draftStatus.name) || 'Draft');
  var _b = __read(React.useState(false), 2),
    moreVisible = _b[0],
    setMoreVisible = _b[1];
  var statusIsOn = statusValue === PUBLISHED;
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var createAction = statusIsOn ? 'Publish %s' : statusValue ? 'Save %s Draft' : 'Save %s';
  var updateAction = statusIsOn ? 'Save Changes' : 'Save Changes';
  var submitButton = React.createElement(My.SubmitButton, {
    disabled: submitting,
    type: "submit"
  }, isCreate ? t(entityTypeName ? (0, sprintf_js_1.sprintf)(createAction, definition.label) : 'Submit') : t(updateAction));
  var toggle = function () {
    onChangeStatus(statusValue === PUBLISHED ? DRAFT : PUBLISHED);
  };
  return React.createElement(My.Container, {
    className: className
  }, React.createElement(My.StartEnd, {
    isVisible: moreVisible
  }, !submitting && React.createElement(React.Fragment, null, startControls ? React.createElement(My.Start, null, startControls) : React.createElement("div", null), React.createElement(My.StatusAndDelete, null, statusValue && React.createElement(My.StatusToggle, {
    showDeleteButton: showDeleteButton,
    onClick: toggle,
    onLabel: onLabel,
    offLabel: offLabel,
    isOn: statusIsOn
  }), showDeleteButton && React.createElement(My.DeleteButton, {
    onClick: onDelete
  }, t('Delete'))))), React.createElement(My.MoreButton, {
    isActive: moreVisible,
    onClick: function () {
      return setMoreVisible(!moreVisible);
    },
    icon: React.createElement(Icons.EllipsisCircle, null)
  }), React.createElement(My.Buttons, {
    _center: !paginate
  }, submitButton));
};
exports.FormControls = FormControls;
exports.FormControls.defaultProps = exports.FormControlsDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30;